// Optional: Add a delay to show the tooltip after a slight pause on hover
document.querySelectorAll('.tooltip-trigger').forEach(function(element) {
  let tooltip = element.nextElementSibling;

  element.addEventListener('mouseenter', function() {
    setTimeout(function() {
      tooltip.style.opacity = 1;
      tooltip.style.visibility = 'visible';
    }, 300); // Delay before showing the tooltip
  });

  element.addEventListener('mouseleave', function() {
    tooltip.style.opacity = 0;
    tooltip.style.visibility = 'hidden'; // Hide tooltip when mouse leaves
  });
});
